<div class="input-group input-group-sm">
  <input
    class="form-control form-control-sm"
    placeholder="mm/dd/yyyy"
    name="dp"
    data-test-selector="date-cell-editor-input"
    [container]="'body'"
    (dateSelect)="onDateSelection($event)"
    [startDate]="ngbDate"
    [(ngModel)]="ngbDate"
    [minDate]="minDate"
    ngbDatepicker
    #d="ngbDatepicker"
  />

  <button
    class="btn btn-outline-secondary"
    data-test-selector="date-cell-editor-button"
    (click)="d.toggle()"
    type="button">
    <i class="fal fa-calendar-alt"></i>
  </button>
</div>
